import React from 'react';
import { MusicDistributionClientContext } from '../../context/MusicDistributionClientContext';
import MusicAlbumFirstPageRegistrationFormView from './MusicAlbumFirstPageRegistrationFormView';
import useCustomForm from '../../../common/hooks/CustomForm';
import { FieldValidationErrorsType, showErrorFlush } from '../../../common/form/FrekulForm';

export default function MusicAlbumFirstPageRegistrationForm() {
  const { signIn, signUp } = React.useContext(MusicDistributionClientContext);

  type FieldName =
    'artist_registration_type'|'artist_registration_mbmail'|
    'artist_registration_password'|'artist_registration_agreement';
  type ValuesType = { [name in FieldName]: string };
  type ErrorsType = { [name in FieldName]?: FieldValidationErrorsType };
  const [values, errors, setValues, setErrors] = useCustomForm<ValuesType, ErrorsType, { name: FieldName }>({
    defaultValue: {
      'artist_registration_type': '',
      'artist_registration_mbmail': '',
      'artist_registration_password': '',
      'artist_registration_agreement': '0',
    }
  });

  const handleSubmit = () => {
    if (values.artist_registration_type === 'signup') {
      signUp(
        values.artist_registration_mbmail,
        values.artist_registration_password,
        values.artist_registration_agreement !== '0'
      ).then((responseData) => {
        if (responseData.result) {
          document.location.href = '/music_albums';
        } else {
          showErrorFlush('入力内容に不備があります。');
          setErrors(responseData.validationErrors || {});
        }
      });
    } else if (values.artist_registration_type === 'auth') {
      signIn(
        values.artist_registration_mbmail,
        values.artist_registration_password
      ).then((responseData) => {
        if (responseData.result) {
          document.location.href = '/music_albums';
        } else {
          showErrorFlush('入力内容に不備があります。');
          setErrors(responseData.validationErrors || {});
        }
      });
    }
  };

  return (
    <MusicAlbumFirstPageRegistrationFormView
      getValue={(name) => values[name]}
      setValue={(name, value) => setValues({ ...values, [name]: value }, { name })}
      getErrors={(name) => errors?.[name] || {}}
      onSubmit={() => handleSubmit()}
    />
  );
}
